
import React from 'react';
import { FeedbackRequest } from '../hooks/useFeedbackRequest';
import {
  CardHeader,
  CardTitle,
  CardDescription,
} from '@/components/ui/card';

export type FormHeaderProps = {
  request: FeedbackRequest | null;
};

export const FormHeader: React.FC<FormHeaderProps> = ({ request }) => {
  if (!request) return null;
  
  // Determine if it's a candidate to recruiter or recruiter to candidate context
  const isRecruiterToCandidate = request.direction === 'recruiter_to_candidate';
  const isCandidateToRecruiter = request.direction === 'candidate_to_recruiter';
  
  return (
    <CardHeader className="space-y-1">
      <CardTitle className="text-2xl font-bold">
        {isCandidateToRecruiter 
          ? 'Donner votre feedback sur le processus de recrutement'
          : isRecruiterToCandidate
          ? 'Donner votre feedback sur la candidature'
          : 'Donner votre feedback'}
      </CardTitle>
      <CardDescription>
        {request.recruiter_name && (
          <>
            {isCandidateToRecruiter ? 'Demandé à ' : 'Demandé par '}
            {request.recruiter_name}
            {request.recruiter_company && ` (${request.recruiter_company})`}
          </>
        )}
        {request.context && (
          <div className="mt-1">
            Contexte: {request.context}
          </div>
        )}
      </CardDescription>
    </CardHeader>
  );
};
